import React from 'react';
import { CustomerDecisionOptionsType, ProductItem, REJECT_ALTERNATIVE, WAIT_FOR_RESTOCK_OF_ORIGINAL_PRODUCT } from "./AlternativeOfferModal";
import * as translator from "../../../utils/translator";
import { useParams } from 'react-router-dom';

type Props = {
    onCustomerChoiceChange: (originalProductItemID: number, alternativeProductItemID: CustomerDecisionOptionsType) => void;
    originalProduct: ProductItem;
    treatAsMultipleProductsOrder: boolean;
}

export const NoSuitableAlternativeContainer: React.FC<Props> = ({
    onCustomerChoiceChange,
    originalProduct,
    treatAsMultipleProductsOrder
}) => {
    const { country } = useParams();

    return (
        <div className="no-suitable-alternative-container">
            {/* "alternative for" title */}
            <p className="alternative-for">
                {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/alternative_for")}
                <span className="alternative-for-original-product-name"> {originalProduct.title}</span>
            </p>

            {/* orange box with explanation text */}
            <div className="no-suitable-alternative-description-box">
                {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/orange_box_text")}
            </div>

            <div className="no-suitable-alternative-instructions">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/no_suitable_alternative_sub_title")}</div>

            <div className="wait-or-cancel-container">
                {/* wait 10 days button */}
                <div className="wait-for-restock-container">
                    {/* title */}
                    {
                        treatAsMultipleProductsOrder ?
                            <div className="no-alternative-card-title">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/wait_for_your_order_title_multiple_products")}:</div>
                            :
                            <div className="no-alternative-card-title">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/wait_for_your_order_title_single_product")}:</div>
                    }

                    {/* description */}
                    <div className="no-alternative-card-description">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/wait_for_your_order_description")}</div>

                    {/* action / button */}
                    <button
                        className="action-button no-suitable-alternative-button"
                        id="wait-for-restock-button"
                        onClick={() => onCustomerChoiceChange(originalProduct.product_item_id, WAIT_FOR_RESTOCK_OF_ORIGINAL_PRODUCT)}
                    >
                        {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/wait_10_days_button")}
                    </button>
                </div>

                {/* cancel oder /  products */}
                <div className="cancel-order-container">
                    {/* title */}
                    {
                        treatAsMultipleProductsOrder ?
                            <div className="no-alternative-card-title">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/cancel_unavailable_product_button_multiple_products")}:</div>
                            :
                            <div className="no-alternative-card-title">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/cancel_unavailable_product_button_single_product")}:</div>
                    }

                    {/* description */}
                    <div className="no-alternative-card-description">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/cancel_order_description")}</div>

                    {/* action / button */}
                    <button
                        className="action-button no-suitable-alternative-button"
                        id="reject-offer-button"
                        onClick={() => onCustomerChoiceChange(originalProduct.product_item_id, REJECT_ALTERNATIVE)}
                    >
                        {
                            treatAsMultipleProductsOrder ?  
                                translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/cancel_order_button_multiple_products")
                                :
                                translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/cancel_order_button_single_product")
                        }
                    </button>
                </div>
            </div>
        </div>
    );
} 